import React from "react";
import { Container } from "./styles/previewModal";

export default function ModalWrapper({ children, ...props }) {
  return <Container {...props}>{children}</Container>;
}